import { createContext } from 'react';

/**
 * @deprecated moved to marketplace-ui-common/layout/context
 */
export const WindowDimensionsContext = /*#__PURE__*/createContext({
  width: window.innerWidth,
  height: window.innerHeight,
  deviceWidth: window.screen.width,
  deviceHeight: window.screen.height
});